import { Expose } from 'class-transformer';

export class ButtonProps {
  @Expose()
  label!: string;

  @Expose()
  disabled?: boolean;

  @Expose()
  block?: boolean;

  @Expose()
  type?: string;

  @Expose()
  outlined!: boolean;

  @Expose()
  extra!: {
    tel?: string;
    mailto?: string;
  } | null;

  @Expose()
  action!: number;
}
